<template>
  <div class="" v-if="UserAccess == 'SHOWTHISPAGE'">
    <b-card>
      <b-row
        ><b-col>
          <div class="DeviceInfoTop">
            <div class="DeviceOverview">
              <VueApexCharts
                type="bar"
                :options="chartOptionsLine"
                :series="seriesLine"
              >
              </VueApexCharts>
            </div>

            <div class="PieChartDiv">
              <VueApexCharts
                type="donut"
                :options="optionsDonut"
                :series="seriesDonut"
              >
              </VueApexCharts>
            </div>
          </div> </b-col
      ></b-row>
    </b-card>
    <b-row
      ><b-col><br /></b-col
    ></b-row>

    <b-row>
      <b-card-group class="col-md-12" deck
        ><b-card
          border-variant="info"
          header="Potential Pathogen Interventions"
          header-bg-variant="info"
          align="center"
        >
          <b-row>
            <b-col>
              <h5>Today:</h5>
            </b-col>
            <b-col>
              <h5>Week:</h5>
            </b-col>
            <b-col>
              <h5>Month:</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5>{{ this.PathogenInterventions.InterventionsToday }}</h5>
            </b-col>
            <b-col>
              <h5>{{ this.PathogenInterventions.Interventions1Week }}</h5>
            </b-col>
            <b-col>
              <h5>{{ this.PathogenInterventions.Interventions4Weeks }}</h5>
            </b-col>
          </b-row>
        </b-card>
        <b-card
          no-body
          header-bg-variant="info"
          border-variant="info"
          header="Monthly Cost Savings"
          class="text-center"
        >
          <b-row no-gutters>
            <b-col>
              <b-card-body>
                <h5>
                  Water Cost Savings : £
                  {{ this.MonthlySavings.FourWeekWaterCostSavings }}
                </h5>
                <h5>
                  Water Savings :
                  {{ this.MonthlySavings.FourWeekWaterLitreSavings }} Litres
                </h5>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
        <b-card
          no-body
          header-bg-variant="info"
          border-variant="info"
          header="Monthly Consumables Savings"
          class="text-center"
        >
          <b-row no-gutters>
            <b-col>
              <b-card-body>
                <b-card-text>
                  <br />
                  <h5>
                    Soap & Gel Savings :
                    {{ this.MonthlySavings.FourWeekConsumableSavings }} Litres
                  </h5>
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card></b-card-group
      >
    </b-row>
    <br />
    <b-row>
      <b-col> </b-col>
    </b-row>
    <hr />
    <b-row
      ><b-col><br /></b-col
    ></b-row>
    <b-tabs fill>
      <b-tab title="Device Overview" lazy>
        <b-card>
          <b-row><p>Icon Key</p></b-row>
          <b-list-group horizontal="md">
            <b-list-group-item
              ><b-avatar
                class="defaultBadge"
                v-b-tooltip.hover
                title="Flush"
                variant="info"
                >F</b-avatar
              ><span class="legendText">
                Flush
              </span></b-list-group-item
            >
            <b-list-group-item
              ><b-avatar
                class="defaultBadge"
                variant="success"
                v-b-tooltip.hover
                title="Handwash"
                >H</b-avatar
              ><span class="legendText"> Handwash </span></b-list-group-item
            >
          </b-list-group>
        </b-card>
        <!-- </b-collapse> -->

        <b-row><p>Device Overview</p></b-row>

        <b-card-group deck>
          <b-card
            border-variant="dark"
            align="center"
            :header-bg-variant="id.ScoreVariant"
            footer-bg-variant=""
            v-for="(id, idx) in this.WBUData"
            class="ThreeWideRepeatDash"
            :key="idx"
          >
            <template #header>
              <h4 class="left">{{ id.id }}</h4>
              <BIconDashSquare
                v-if="id.Trending == 'STABLE'"
                font-scale="1.5"
                v-b-tooltip.hover
                title="Stable"
              >
              </BIconDashSquare>
              <BIconArrowUpRightSquare
                v-if="id.Trending == 'UP'"
                font-scale="1.5"
                v-b-tooltip.hover
                title="Trending Up"
              ></BIconArrowUpRightSquare>
              <BIconArrowDownRightSquare
                v-if="id.Trending == 'DOWN'"
                font-scale="1.5"
                v-b-tooltip.hover
                title="Trending Down"
              >
              </BIconArrowDownRightSquare>
            </template>
            <template #footer>
              <b-button variant="dark" @click="showdetails(id)"
                >Details</b-button
              >
            </template>
            <b-card-sub-title class="mb-2">{{ id.DeptFloor }}</b-card-sub-title>

            <b-row
              ><b-col><p class="cardhead">Last Flow</p></b-col
              ><b-col><p class="cardhead">Biofilm Risk</p></b-col></b-row
            >
            <b-row
              ><b-col class="cardcol"
                ><p class="cardbody">
                  {{ id.LastFlowTime }} Hours Ago
                  <b-avatar
                    v-if="id.FlowType != 'Flush'"
                    class="HandwashIcon"
                    variant="success"
                    v-b-tooltip.hover
                    title="Handwash"
                    >H</b-avatar
                  >
                  <b-avatar
                    v-if="id.FlowType == 'Flush'"
                    class="defaultBadge"
                    variant="info"
                    v-b-tooltip.hover
                    title="Flush"
                    >F</b-avatar
                  >
                </p> </b-col
              ><b-col class="cardcol"
                ><p class="cardbody">
                  <b-badge variant="success">Low</b-badge>
                  <!-- <b-badge variant="warning">Moderate</b-badge>
              <b-badge variant="danger">High</b-badge> -->
                </p></b-col
              ></b-row
            >
            <b-row
              ><b-col><br /></b-col
            ></b-row>
            <b-row
              ><b-col><p class="cardhead">Cold</p></b-col
              ><b-col><p class="cardhead">Hot</p></b-col></b-row
            >
            <b-row
              ><b-col class="cardcol"
                ><p class="cardbody">{{ id.AvgColdTemp }}&#8451;</p></b-col
              ><b-col class="cardcol"
                ><p class="cardbody">{{ id.AvgHotTemp }}&#8451;</p></b-col
              ></b-row
            >
          </b-card>
        </b-card-group>

        <!-- HARD CODED BOXES BELOW -->
        <b-card-group deck>
          <b-card
            border-variant="dark"
            align="center"
            header-bg-variant="success"
            footer-bg-variant=""
          >
            <template #header>
              <h4 class="left">MIC154325343</h4>
              <BIconArrowUpRightSquare
                font-scale="1.5"
              ></BIconArrowUpRightSquare>
            </template>
            <template #footer>
              <b-button variant="dark" @click="showdetails()">Details</b-button>
            </template>
            <b-card-sub-title class="mb-2">ICU Ward 2</b-card-sub-title>

            <b-row
              ><b-col><p class="cardhead">Last Flow</p></b-col
              ><b-col><p class="cardhead">Biofilm Risk</p></b-col></b-row
            >
            <b-row
              ><b-col class="cardcol"
                ><p class="cardbody">
                  2 Hours Ago
                  <b-avatar
                    class="HandwashIcon"
                    variant="success"
                    v-b-tooltip.hover
                    title="Handwash"
                    >H</b-avatar
                  >
                </p> </b-col
              ><b-col class="cardcol"
                ><p class="cardbody">
                  <b-badge variant="success">Low</b-badge>
                </p></b-col
              ></b-row
            >
            <b-row
              ><b-col><br /></b-col
            ></b-row>
            <b-row
              ><b-col><p class="cardhead">Hot</p></b-col
              ><b-col><p class="cardhead">Cold</p></b-col
              ><b-col><p class="cardhead">Mixed</p></b-col></b-row
            >
            <b-row
              ><b-col class="cardcol"><p class="cardbody">11&#8451;</p></b-col
              ><b-col class="cardcol"><p class="cardbody">24&#8451;</p></b-col
              ><b-col class="cardcol"
                ><p class="cardbody">39&#8451;</p></b-col
              ></b-row
            >
          </b-card>
          <b-card
            header-text-variant="dark"
            border-variant="dark"
            header-bg-variant="warning"
            align="center"
            footer-tag="footer"
          >
            <b-card-sub-title class="mb-2">Maternity Ward 6</b-card-sub-title>
            <template #header>
              <h4 class="left">GABw09u0d9ud</h4>
              <BIconDashSquare font-scale="1.5"></BIconDashSquare>
            </template>
            <template #footer>
              <b-button variant="dark" @click="showdetails()">Details</b-button>
            </template>
            <b-row
              ><b-col><p class="cardhead">Last Flow</p></b-col
              ><b-col><p class="cardhead">Biofilm Risk</p></b-col></b-row
            >
            <b-row
              ><b-col class="cardcol"
                ><p class="cardbody">
                  1 Hour Ago
                  <b-avatar
                    class="defaultBadge"
                    variant="info"
                    v-b-tooltip.hover
                    title="Flush"
                    >F</b-avatar
                  >
                </p></b-col
              ><b-col class="cardcol"
                ><p class="cardbody">
                  <b-badge variant="warning">Moderate</b-badge>
                </p></b-col
              ></b-row
            >
            <b-row
              ><b-col><br /></b-col
            ></b-row>
            <b-row
              ><b-col><p class="cardhead">Hot</p></b-col
              ><b-col><p class="cardhead">Cold</p></b-col
              ><b-col><p class="cardhead">Mixed</p></b-col></b-row
            >
            <b-row
              ><b-col class="cardcol"><p class="cardbody">19&#8451;</p></b-col
              ><b-col class="cardcol"><p class="cardbody">65&#8451;</p></b-col
              ><b-col class="cardcol"
                ><p class="cardbody">41&#8451;</p></b-col
              ></b-row
            >
          </b-card>
          <b-card
            header-text-variant="dark"
            border-variant="dark"
            header-bg-variant="danger"
            align="center"
            footer-tag="footer"
          >
            <b-card-sub-title class="mb-2">Dental Surgery 1</b-card-sub-title>
            <template #header>
              <h4 class="left">MIC872345617H</h4>
              <BIconArrowDownRightSquare
                font-scale="1.5"
              ></BIconArrowDownRightSquare>
            </template>
            <template #footer>
              <b-button variant="dark" @click="showdetails()">Details</b-button>
            </template>
            <b-row
              ><b-col><p class="cardhead">Last Flow</p></b-col
              ><b-col><p class="cardhead">Biofilm Risk</p></b-col></b-row
            >
            <b-row
              ><b-col class="cardcol"
                ><p class="cardbody">
                  3 Hours Ago
                  <b-avatar
                    class="defaultBadge"
                    variant="info"
                    v-b-tooltip.hover
                    title="Flush"
                    >F</b-avatar
                  >
                </p></b-col
              ><b-col class="cardcol"
                ><p class="cardbody">
                  <b-badge variant="warning">Moderate</b-badge>
                </p></b-col
              ></b-row
            >
            <b-row
              ><b-col><br /></b-col
            ></b-row>
            <b-row
              ><b-col><p class="cardhead">Hot</p></b-col
              ><b-col><p class="cardhead">Cold</p></b-col
              ><b-col><p class="cardhead">Mixed</p></b-col></b-row
            >
            <b-row
              ><b-col class="cardcol"><p class="cardbody">19&#8451;</p></b-col
              ><b-col class="cardcol"><p class="cardbody">65&#8451;</p></b-col
              ><b-col class="cardcol"
                ><p class="cardbody">41&#8451;</p></b-col
              ></b-row
            >
          </b-card>
        </b-card-group>
        <b-row
          ><b-col><br /></b-col
        ></b-row>
      </b-tab>
      <b-tab title="Device Management" lazy>
        <WashbasinAdmin></WashbasinAdmin>
      </b-tab>
    </b-tabs>
    <!-- <b-row>
      <b-col>
        <b-button v-b-toggle.collapse-1 variant="outline-secondary" size="sm"
          >Icon Key</b-button
        >
      </b-col>
    </b-row> -->
    <!-- <b-collapse id="collapse-1" class="mt-2"> -->
    <!-- <b-card>
      <b-row><p>Icon Key</p></b-row>
      <b-list-group horizontal="md">
        <b-list-group-item
          ><b-avatar
            class="defaultBadge"
            v-b-tooltip.hover
            title="Flush"
            variant="info"
            >F</b-avatar
          ><span class="legendText">
            Flush
          </span></b-list-group-item
        >
        <b-list-group-item
          ><b-avatar
            class="defaultBadge"
            variant="success"
            v-b-tooltip.hover
            title="Handwash"
            >H</b-avatar
          ><span class="legendText"> Handwash </span></b-list-group-item
        >
      </b-list-group>
    </b-card>
    </b-collapse> 

    <b-row><p>Device Overview</p></b-row>

    <b-card-group deck>
      <b-card
        border-variant="dark"
        align="center"
        :header-bg-variant="id.ScoreVariant"
        footer-bg-variant=""
        v-for="(id, idx) in this.WBUData"
        class="ThreeWideRepeatDash"
        :key="idx"
      >
        <template #header>
          <h4 class="left">{{ id.id }}</h4>
          <BIconDashSquare
            v-if="id.Trending == 'STABLE'"
            font-scale="1.5"
            v-b-tooltip.hover
            title="Stable"
          >
          </BIconDashSquare>
          <BIconArrowUpRightSquare
            v-if="id.Trending == 'UP'"
            font-scale="1.5"
            v-b-tooltip.hover
            title="Trending Up"
          ></BIconArrowUpRightSquare>
          <BIconArrowDownRightSquare
            v-if="id.Trending == 'DOWN'"
            font-scale="1.5"
            v-b-tooltip.hover
            title="Trending Down"
          >
          </BIconArrowDownRightSquare>
        </template>
        <template #footer>
          <b-button variant="dark" @click="showdetails(id)">Details</b-button>
        </template>
        <b-card-sub-title class="mb-2">{{ id.DeptFloor }}</b-card-sub-title>

        <b-row
          ><b-col><p class="cardhead">Last Flow</p></b-col
          ><b-col><p class="cardhead">Biofilm Risk</p></b-col></b-row
        >
        <b-row
          ><b-col class="cardcol"
            ><p class="cardbody">
              {{ id.LastFlowTime }} Hours Ago
              <b-avatar
                v-if="id.FlowType != 'Flush'"
                class="HandwashIcon"
                variant="success"
                v-b-tooltip.hover
                title="Handwash"
                >H</b-avatar
              >
              <b-avatar
                v-if="id.FlowType == 'Flush'"
                class="defaultBadge"
                variant="info"
                v-b-tooltip.hover
                title="Flush"
                >F</b-avatar
              >
            </p> </b-col
          ><b-col class="cardcol"
            ><p class="cardbody">
              <b-badge variant="success">Low</b-badge>
               <b-badge variant="warning">Moderate</b-badge>
              <b-badge variant="danger">High</b-badge> 
            </p></b-col
          ></b-row
        >
        <b-row
          ><b-col><br /></b-col
        ></b-row>
        <b-row
          ><b-col><p class="cardhead">Cold</p></b-col
          ><b-col><p class="cardhead">Hot</p></b-col></b-row
        >
        <b-row
          ><b-col class="cardcol"
            ><p class="cardbody">{{ id.AvgColdTemp }}&#8451;</p></b-col
          ><b-col class="cardcol"
            ><p class="cardbody">{{ id.AvgHotTemp }}&#8451;</p></b-col
          ></b-row
        >
      </b-card>
    </b-card-group>

     HARD CODED BOXES BELOW 
    <b-card-group deck>
      <b-card
        border-variant="dark"
        align="center"
        header-bg-variant="success"
        footer-bg-variant=""
      >
        <template #header>
          <h4 class="left">MIC154325343</h4>
          <BIconArrowUpRightSquare font-scale="1.5"></BIconArrowUpRightSquare>
        </template>
        <template #footer>
          <b-button variant="dark" @click="showdetails()">Details</b-button>
        </template>
        <b-card-sub-title class="mb-2">ICU Ward 2</b-card-sub-title>

        <b-row
          ><b-col><p class="cardhead">Last Flow</p></b-col
          ><b-col><p class="cardhead">Biofilm Risk</p></b-col></b-row
        >
        <b-row
          ><b-col class="cardcol"
            ><p class="cardbody">
              2 Hours Ago
              <b-avatar
                class="HandwashIcon"
                variant="success"
                v-b-tooltip.hover
                title="Handwash"
                >H</b-avatar
              >
            </p> </b-col
          ><b-col class="cardcol"
            ><p class="cardbody">
              <b-badge variant="success">Low</b-badge>
            </p></b-col
          ></b-row
        >
        <b-row
          ><b-col><br /></b-col
        ></b-row>
        <b-row
          ><b-col><p class="cardhead">Hot</p></b-col
          ><b-col><p class="cardhead">Cold</p></b-col
          ><b-col><p class="cardhead">Mixed</p></b-col></b-row
        >
        <b-row
          ><b-col class="cardcol"><p class="cardbody">11&#8451;</p></b-col
          ><b-col class="cardcol"><p class="cardbody">24&#8451;</p></b-col
          ><b-col class="cardcol"
            ><p class="cardbody">39&#8451;</p></b-col
          ></b-row
        >
      </b-card>
      <b-card
        header-text-variant="dark"
        border-variant="dark"
        header-bg-variant="warning"
        align="center"
        footer-tag="footer"
      >
        <b-card-sub-title class="mb-2">Maternity Ward 6</b-card-sub-title>
        <template #header>
          <h4 class="left">GABw09u0d9ud</h4>
          <BIconDashSquare font-scale="1.5"></BIconDashSquare>
        </template>
        <template #footer>
          <b-button variant="dark" @click="showdetails()">Details</b-button>
        </template>
        <b-row
          ><b-col><p class="cardhead">Last Flow</p></b-col
          ><b-col><p class="cardhead">Biofilm Risk</p></b-col></b-row
        >
        <b-row
          ><b-col class="cardcol"
            ><p class="cardbody">
              1 Hour Ago
              <b-avatar
                class="defaultBadge"
                variant="info"
                v-b-tooltip.hover
                title="Flush"
                >F</b-avatar
              >
            </p></b-col
          ><b-col class="cardcol"
            ><p class="cardbody">
              <b-badge variant="warning">Moderate</b-badge>
            </p></b-col
          ></b-row
        >
        <b-row
          ><b-col><br /></b-col
        ></b-row>
        <b-row
          ><b-col><p class="cardhead">Hot</p></b-col
          ><b-col><p class="cardhead">Cold</p></b-col
          ><b-col><p class="cardhead">Mixed</p></b-col></b-row
        >
        <b-row
          ><b-col class="cardcol"><p class="cardbody">19&#8451;</p></b-col
          ><b-col class="cardcol"><p class="cardbody">65&#8451;</p></b-col
          ><b-col class="cardcol"
            ><p class="cardbody">41&#8451;</p></b-col
          ></b-row
        >
      </b-card>
      <b-card
        header-text-variant="dark"
        border-variant="dark"
        header-bg-variant="danger"
        align="center"
        footer-tag="footer"
      >
        <b-card-sub-title class="mb-2">Dental Surgery 1</b-card-sub-title>
        <template #header>
          <h4 class="left">MIC872345617H</h4>
          <BIconArrowDownRightSquare
            font-scale="1.5"
          ></BIconArrowDownRightSquare>
        </template>
        <template #footer>
          <b-button variant="dark" @click="showdetails()">Details</b-button>
        </template>
        <b-row
          ><b-col><p class="cardhead">Last Flow</p></b-col
          ><b-col><p class="cardhead">Biofilm Risk</p></b-col></b-row
        >
        <b-row
          ><b-col class="cardcol"
            ><p class="cardbody">
              3 Hours Ago
              <b-avatar
                class="defaultBadge"
                variant="info"
                v-b-tooltip.hover
                title="Flush"
                >F</b-avatar
              >
            </p></b-col
          ><b-col class="cardcol"
            ><p class="cardbody">
              <b-badge variant="warning">Moderate</b-badge>
            </p></b-col
          ></b-row
        >
        <b-row
          ><b-col><br /></b-col
        ></b-row>
        <b-row
          ><b-col><p class="cardhead">Hot</p></b-col
          ><b-col><p class="cardhead">Cold</p></b-col
          ><b-col><p class="cardhead">Mixed</p></b-col></b-row
        >
        <b-row
          ><b-col class="cardcol"><p class="cardbody">19&#8451;</p></b-col
          ><b-col class="cardcol"><p class="cardbody">65&#8451;</p></b-col
          ><b-col class="cardcol"
            ><p class="cardbody">41&#8451;</p></b-col
          ></b-row
        >
      </b-card>
    </b-card-group>
    <b-row
      ><b-col><br /></b-col
    ></b-row> -->

    <b-modal
      ref="WashbasinDetailsModal"
      id="WashbasinDetailsModal"
      title="Washbasin Device Details"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
    >
      <b-card
        header=""
        header-text-variant="dark"
        border-variant="dark"
        :header-bg-variant="WashbasinDetails.ScoreVariant"
        align="center"
      >
        <b-card-sub-title class="mb-2">Dental Surgery 1</b-card-sub-title>
        <template #header>
          <h4 class="left">{{ WashbasinDetails.id }}</h4>
          <BIconDashSquare
            v-if="WashbasinDetails.Trending == 'STABLE'"
            font-scale="1.5"
            v-b-tooltip.hover
            title="Stable"
          >
          </BIconDashSquare>
          <BIconArrowUpRightSquare
            v-if="WashbasinDetails.Trending == 'UP'"
            font-scale="1.5"
            v-b-tooltip.hover
            title="Trending Up"
          ></BIconArrowUpRightSquare>
          <BIconArrowDownRightSquare
            v-if="WashbasinDetails.Trending == 'DOWN'"
            font-scale="1.5"
            v-b-tooltip.hover
            title="Trending Down"
          >
          </BIconArrowDownRightSquare>
        </template>
        <b-row
          ><b-col><p class="cardhead">Last Flow</p></b-col
          ><b-col><p class="cardhead">Biofilm Risk</p></b-col></b-row
        >
        <b-row
          ><b-col class="cardcol"
            ><p class="cardbody">
              {{ WashbasinDetails.LastFlowTime }} Hours Ago
            </p></b-col
          ><b-col class="cardcol"
            ><p class="cardbody">
              <b-badge variant="warning">Moderate</b-badge>
            </p></b-col
          ></b-row
        >
        <b-row
          ><b-col><br /></b-col
        ></b-row>
        <b-row
          ><b-col><p class="cardhead">Cold</p></b-col
          ><b-col><p class="cardhead">Hot</p></b-col></b-row
        >
        <b-row
          ><b-col class="cardcol"
            ><p class="cardbody">
              {{ WashbasinDetails.AvgColdTemp }}&#8451;
            </p></b-col
          ><b-col class="cardcol"
            ><p class="cardbody">
              {{ WashbasinDetails.AvgHotTemp }}&#8451;
            </p></b-col
          ></b-row
        >
      </b-card>
      <br />
      <b-card-group>
        <b-card
          header="SubGroup"
          header-bg-variant="info"
          border-variant="info"
          align="center"
          >High Risk</b-card
        >
        <b-card
          border-variant="info"
          header="Pathogen Interventions"
          header-bg-variant="info"
          align="center"
          footer-tag="footer"
        >
          <h5>{{ WashbasinDetails.InterventionCount }}</h5>
          <template #footer>
            <p class="tiny">(month to date)</p>
          </template>
        </b-card>
      </b-card-group>
      <b-card-group>
        <b-card
          border-variant="info"
          header="Water Cost Savings"
          header-bg-variant="info"
          align="center"
          footer-tag="footer"
        >
          <h5>£1.23</h5>
          <template #footer>
            <p class="tiny">(month to date)</p>
          </template>
        </b-card>
        <b-card
          border-variant="info"
          header="Consumable Cost Savings"
          header-bg-variant="info"
          align="center"
          footer-tag="footer"
        >
          <h5>£0.92</h5>
          <template #footer>
            <p class="tiny">(month to date)</p>
          </template>
        </b-card>
      </b-card-group>
      <br />
      <b-card border-variant="dark" footer-tag="footer" align="center">
        <b-avatar
          button
          rounded
          variant="outline-info"
          class="left"
          v-b-tooltip.hover
          title="Notes"
          ><BIconFileEarmarkMedical></BIconFileEarmarkMedical
        ></b-avatar>
        <b-avatar
          button
          rounded
          variant="outline-info"
          class="right"
          v-b-tooltip.hover
          title="File Upload"
          ><BIconCloudUpload></BIconCloudUpload
        ></b-avatar>
        <template #footer>
          <b-row
            ><b-col
              ><b-button variant="outline-info" size="sm"
                >Device Details</b-button
              ></b-col
            >
            <b-col
              ><b-button
                size="sm"
                variant="outline-info"
                v-on:click="DeviceReportGen('GAB2987615000', 'HW')"
                >Trend Reports</b-button
              ></b-col
            >
          </b-row>
        </template>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import Vue from "vue";
import axios from "axios";
import "vue-slider-component/theme/default.css";
import WashbasinAdmin from "../views/WashbasinAdmin.vue";
import {
  BIconFileEarmarkMedical,
  BIconCloudUpload,
  BIconDashSquare,
  BIconArrowUpRightSquare,
  BIconArrowDownRightSquare,
} from "bootstrap-vue";

export default {
  components: {
    BIconFileEarmarkMedical,
    BIconCloudUpload,
    BIconDashSquare,
    BIconArrowDownRightSquare,
    BIconArrowUpRightSquare,
    VueApexCharts,
    WashbasinAdmin,
  },

  data() {
    return {
      UserAccess: "",
      perPage: 10,
      currentPage: 1,
      AlarmItems: [],
      UserHeaders: [],
      ArrTest: [],
      ErrorHeaders: [],
      ErrorItems: [],
      SupportItems: [],
      SupportHeaders: [],
      ServiceItems: [],
      ServiceHeaders: [],
      location: "",
      locations: [],
      filteredlocations: [],
      modal: false,
      GreenCount: "--",
      AmberCount: "--",
      RedCount: "--",
      responseArray: [],
      responselist: [],
      CompanyName: this.$Company,
      GoodState: "7",
      ExcellentState: "2",
      BadState: "1",
      FairState: "4",
      locationsArray: [],
      locationsList: [],
      deviceLocation: this.$Location,
      hover: false,
      TodayDate: "",
      TotalDevices: "14",
      time: "",
      value: "999",
      max: "999",
      DeviceMessage: "Total Devices for ",
      resetButtonDisable: false,
      selectedlocation: localStorage.getItem("CurrentLocation"),

      feedList: [],
      Positions: [],
      feedArray: [],
      PositionArray: [],
      subgroupListArray: [],
      subgroupList: "",
      dbFilterRecirculatory: "",
      dbFilterOutdoor: "",
      dbFilterMultiplePipe: "",
      dbFilterBattery: "",
      dbFilterHealthcare: "",
      dbFilterRiskLevel: "",
      dbFilterPosition: "",
      dbFilterFeed: "",
      dbFilterDeviceLocation: "",
      dbFilterDeviceOrder: "",
      dbFilterSubgroup: "",
      chartOptionsLine: {
        dataLabels: {
          enabled: false,
        },

        title: {
          text: "7 Day Handwash Flow Data",
          align: "center",
        },

        legend: {
          show: true,
        },
        chart: {},
        sparkline: {
          enabled: true,
        },
        fill: {
          opacity: 1,
        },

        xaxis: {
          categories: ["MIC154325343", "GABw09u0d9ud", "MIC872345617"],
          labels: {
            show: true,
          },
        },
        yaxis: {
          labels: {
            show: true,
          },
        },
        colors: ["#17a2b8", "#7BF0B7"],
        grid: {
          show: true, // you can either change hear to disable all grids
          xaxis: {
            lines: {
              show: true, //or just here to disable only x axis grids
            },
            labels: {
              show: false,
            },
          },
          yaxis: {
            lines: {
              show: false, //or just here to disable only y axis
            },
            axisBorder: {
              show: false,
            },
            labels: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
        },
      },
      seriesLine: [
        {
          name: "No of Flushes",
          data: [6, 28, 20],
        },
        {
          name: "No of Handwashes",
          data: [50, 6, 18],
        },
      ],
      optionsDonut: {
        title: {
          text: "Current Handwash Unit Status",
          align: "center",
        },
        labels: [
          "Extremely High Risk",
          "High Risk",
          "Moderate Risk",
          "Low Risk",
        ],
        colors: ["#dc3545", "#F05E16", "#ffc107", "#28a745"],
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Total no of Handwash Units",
                },
              },
            },
          },
        },
      },
      seriesDonut: [1, 0, 1, 1],

      filterArray: [],
      micitems: [
        {
          DeviceID: "MIC1543254343",
          Position: "ICU Ward 2",
          CurrentStatus: "success",
          HandwashCompliance: "26%",
          Temperatures: [11, 24, 39],
          BiofilmState: "low",
          PathogenInterventions: "2",
          WaterCostSavings: "2.38",
          ConsumableSavings: "0.78",
        },
        {
          DeviceID: "GABw09u0d9ud",
          Position: "Maternity Ward 6",
          CurrentStatus: "warning",
          HandwashCompliance: "13%",
          Temperatures: [19, 65, 41],
          BiofilmState: "med",
          PathogenInterventions: "4",
          WaterCostSavings: "6.01",
          ConsumableSavings: "1.11",
        },
        {
          DeviceID: "MIC872345617H",
          Position: "Dental Surgery 1",
          CurrentStatus: "danger",
          HandwashCompliance: "52%",
          Temperatures: [28, 27, 26],
          BiofilmState: "high",
          PathogenInterventions: "1",
          WaterCostSavings: "0.52",
          ConsumableSavings: "0.39",
        },
      ],
      micfields: [
        "DeviceID",
        "Position",
        "CurrentStatus",
        "HandwashCompliance",
        "Temperatures",
        "BiofilmState",
        "Details",
      ],
      exhighbasins: [
        {
          DeviceID: "MIC872345617H",
          Position: "Dental Surgery 1",
          CurrentStatus: "danger",
          HandwashCompliance: "52%",
          Temperatures: [28, 27, 26],
          BiofilmState: "high",
          PathogenInterventions: "1",
          WaterCostSavings: "0.52",
          ConsumableSavings: "0.39",
        },
      ],
      highbasins: [
        {
          DeviceID: "GABw09u0d9ud",
          Position: "Maternity Ward 6",
          CurrentStatus: "warning",
          HandwashCompliance: "13%",
          Temperatures: [19, 65, 41],
          BiofilmState: "med",
          PathogenInterventions: "4",
          WaterCostSavings: "6.01",
          ConsumableSavings: "1.11",
        },
      ],
      modbasins: [],
      lowbasins: [
        {
          DeviceID: "MIC1543254343",
          Position: "ICU Ward 2",
          CurrentStatus: "success",
          HandwashCompliance: "26%",
          Temperatures: [11, 24, 39],
          BiofilmState: "low",
          PathogenInterventions: "2",
          WaterCostSavings: "2.38",
          ConsumableSavings: "0.78",
        },
      ],
      MonthlySavings: "",
      PathogenInterventions: "",
      WBUData: [],
      ExtremelyHighRiskCount: 0,
      HighRiskCount: 0,
      ModerateRiskCount: 0,
      LowRiskCount: 0,
      WashbasinDetails: "",
    };
  },

  async mounted() {
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/dashboard";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      Report: "WBUnitReport",
      RequestVariable: "Demon Attack HQ",
      DataDict: [
        {
          FilterType: [],
          DeviceSort: "",
          Location: "",
          Subgroup: "",
          Position: "",
        },
      ],
    };

    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        this.MonthlySavings = response.data.MonthlyCostSavings;

        this.PathogenInterventions =
          response.data.Dashboard.PathogenInterventions;

        let WBData = response.data.Values;

        // WBData = WBData + WBData;

        for (let i = 0; i < WBData.length; i++) {
          let DeptFloor = WBData[i][1];
          let HotTemp = WBData[i][9];
          let ColdTemp = WBData[i][10];

          let RightNow = Date.now();
          let FlowTime = new Date(WBData[i][7]);
          let FlowTimeMS = RightNow - FlowTime;
          let FlowTimeHours = FlowTimeMS / 1000 / 60 / 60;

          FlowTimeHours = Math.round(FlowTimeHours);

          let Variant = "";

          if (WBData[i][6] <= 150) {
            Variant = "danger";
            this.ExtremelyHighRiskCount = this.ExtremelyHighRiskCount + 1;
          }
          if ((WBData[i][6] >= 150) & (WBData[i][6] < 500)) {
            Variant = "highRisk";
            this.HighRiskCount = this.HighRiskCount + 1;
          }
          if ((WBData[i][6] >= 500) & (WBData[i][6] < 850)) {
            Variant = "warning";
            this.ModerateRiskCount = this.ModerateRiskCount + 1;
          }
          if (WBData[i][6] >= 850) {
            Variant = "success";
            this.LowRiskCount = this.LowRiskCount + 1;
          }

          // This is the format I get the date and time 2023-02-21 14:42:53

          if (WBData[i][1] == null) {
            DeptFloor = "--";
          }

          if (HotTemp == null) {
            HotTemp = "--";
          }
          if (ColdTemp == null) {
            ColdTemp = "--";
          }

          this.WBUData.push({
            id: WBData[i][0],
            DeptFloor: DeptFloor,
            Position: WBData[i][2],
            LocationNote: WBData[i][3],
            Version: WBData[i][4],
            State: WBData[i][5],
            Score: WBData[i][6],
            LastFlowTime: FlowTimeHours,
            FlowType: WBData[i][8],
            AvgHotTemp: HotTemp,
            AvgColdTemp: ColdTemp,
            InterventionCount: WBData[i][11],
            ScoreVariant: Variant,
            Trending: WBData[i][12],
          });
        }
        this.seriesDonut = [
          this.ExtremelyHighRiskCount,
          this.HighRiskCount,
          this.ModerateRiskCount,
          this.LowRiskCount,
        ];
      });
  },

  methods: {
    setChartData() {
      return {
        labels: [
          "Extremely High Risk",
          "High Risk",
          "Moderate Risk",
          "Low Risk",
        ],
        datasets: [
          {
            borderWidth: 0,

            backgroundColor: ["#dc3545", "#F05E16", "#ffc107", "#28a745"],

            data: [1, 4, 7, 2],
          },
        ],
      };
    },
    setChartOptions() {
      return {
        legend: {
          display: true,
          position: "right",
        },
        cutoutPercentage: 60,
        borderAlign: "center",

        title: {
          display: false,
          text: "Devices",
        },
        responsive: true,
        maintainAspectRatio: false,
      };
    },
    filterDashboardData() {
      this.submitButtonDisable = true;
      this.resetButtonDisable = true;
      (this.responseArray = []), (this.responselist = []);
      this.locations = [];
      this.location = "";
      this.modal = false;
      this.filterArray = [];

      if (this.dbFilterDeviceOrder != "") {
        this.filterArray.push("Device");
      }
      if (this.dbFilterDeviceLocation != "") {
        this.filterArray.push("Location");
      }
      if (this.dbFilterSubgroup != "") {
        this.filterArray.push("Subgroup");
      }
      if (this.dbFilterFeed != "") {
        this.filterArray.push("Feed");
      }
      if (this.dbFilterPosition != "") {
        this.filterArray.push("Position");
      }
      if (this.dbFilterRiskLevel != "") {
        this.filterArray.push("State");
      }
      if (this.dbFilterHealthcare != "") {
        this.filterArray.push("Healthcare");
      }
      if (this.dbFilterRecirculatory != "") {
        this.filterArray.push("Recirculatory");
      }
      if (this.dbFilterBattery != "") {
        this.filterArray.push("Battery");
      }
      if (this.dbFilterMultiplePipe != "") {
        this.filterArray.push("Multipipe");
      }
      if (this.dbFilterOutdoor != "") {
        this.filterArray.push("Outdoor");
      }

      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let LookUpHeadersFeed = this.$apikeyPost;
      this.LookUpRequest = {
        Report: "DeviceReport",
        RequestType: "CEU",
        RequestVariable: this.deviceLocation,
        DataDict: [
          {
            FilterType: this.filterArray,
            DeviceSort: this.dbFilterDeviceOrder,
            Location: this.dbFilterDeviceLocation.text,
            Subgroup: this.dbFilterSubgroup,
            Feed: this.dbFilterFeed,
            Position: this.dbFilterPosition.text,
            State: this.dbFilterRiskLevel,
          },
        ],
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeadersFeed)
        .then((response) => {
          if (response.data.Values == "") {
            this.responseArray = [];
            this.responseArray = ["No Data"];
          } else if (response.data.Values != "") {
            this.responselist = response.data.Values;

            for (let i = 0; i < this.responselist.length; i++) {
              var QuoteStr = this.responselist[i][0];
              var FlowTime = "";
              var FlowDate = "";
              var FlowTimeDate = "";
              var BioFilmLvl = "";

              BioFilmLvl = this.responselist[i][10];
              FlowDate = this.responselist[i][8];
              FlowTime = this.responselist[i][9];
              if (FlowDate != "N/A") {
                FlowTimeDate = FlowDate + FlowTime;
                let d1 = new Date().toUTCString();
                d1 = new Date(d1).getTime();
                let d2 = new Date(FlowTimeDate).getTime();
                this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);
              } else if (FlowDate === "N/A") {
                this.time = "N/A";
              }

              if (BioFilmLvl == "N/A") {
                BioFilmLvl = "NoBio";
              }
              if (QuoteStr.includes("A")) {
                let FlowDate2 = this.responselist[i][8];
                let FlowTime2 = this.responselist[i][9];
                if (FlowDate2 != "N/A") {
                  let FlowTimeDate2 = FlowDate2 + FlowTime2;
                  let d1 = new Date().toUTCString();
                  d1 = new Date(d1).getTime();
                  let d2 = new Date(FlowTimeDate2).getTime();
                  var time2 = Math.floor((d1 - d2) / 1000 / 60 / 60);
                } else if (FlowDate2 === "N/A") {
                  time2 = "N/A";
                }
                let BioFilmLvl2 = this.responselist[i + 1][10];
                if (BioFilmLvl2 == "N/A") {
                  BioFilmLvl2 = "NoBio";
                }

                let DevID = QuoteStr.slice(0, 9);
                let WorstScoreLvl = "";
                if (this.responselist[i][4] > this.responselist[i + 1][4]) {
                  WorstScoreLvl = this.responselist[i + 1][4];
                }

                if (this.responselist[i][4] < this.responselist[i + 1][4]) {
                  WorstScoreLvl = this.responselist[i][4];
                }

                if (this.responselist[i][4] == this.responselist[i + 1][4]) {
                  WorstScoreLvl = this.responselist[i][4];
                }
                this.responseArray.push({
                  DeviceID: DevID,
                  BuildingName: this.responselist[i][1],
                  Position: this.responselist[i][2],
                  Feed: this.responselist[i][3],
                  Recirculatory: this.responselist[i][11],
                  Healthcare: this.responselist[i][12],
                  Outdoor: this.responselist[i][13],
                  Multipipe: this.responselist[i][15],
                  Battery: this.responselist[i][14],
                  Dropdown: "False",
                  Pipe1: {
                    Score: this.responselist[i][4],
                    TempHi: this.responselist[i][5],
                    TempLo: this.responselist[i][6],
                    TempMed: this.responselist[i][7],
                    FlowRead: this.time,
                    PathogenRead: BioFilmLvl,
                  },
                  Pipe2: {
                    Score: this.responselist[i + 1][4],
                    TempHi: this.responselist[i + 1][5],
                    TempLo: this.responselist[i + 1][6],
                    TempMed: this.responselist[i + 1][7],
                    FlowRead: time2,
                    PathogenRead: BioFilmLvl2,
                  },
                  WorstScore: WorstScoreLvl,
                });
              } else if (QuoteStr.length == 9) {
                this.responseArray.push({
                  DeviceID: QuoteStr,
                  BuildingName: this.responselist[i][1],
                  Position: this.responselist[i][2],
                  Feed: this.responselist[i][3],
                  Score: this.responselist[i][4],
                  TempHi: this.responselist[i][5],
                  TempLo: this.responselist[i][6],
                  TempMed: this.responselist[i][7],
                  FlowRead: this.time,
                  PathogenRead: BioFilmLvl,
                  Recirculatory: this.responselist[i][11],
                  Healthcare: this.responselist[i][12],
                  Outdoor: this.responselist[i][13],
                  Multipipe: this.responselist[i][15],
                  Battery: this.responselist[i][14],
                  Dropdown: "False",
                });
              }
            }

            this.DeviceMessage = "Total Devices";
            this.$root.$emit("bv::toggle::collapse", "sidebar-backdrop");
          }
        });
    },

    resetValue: function() {
      this.submitButtonDisable = true;
      this.resetButtonDisable = true;
      (this.responseArray = []), (this.responselist = []);
      this.locations = [];
      this.location = "";
      this.dbFilterRecirculatory = "";
      this.dbFilterOutdoor = "";
      this.dbFilterMultiplePipe = "";
      this.dbFilterBattery = "";
      this.dbFilterHealthcare = "";
      this.dbFilterDeviceLocation = "";
      this.dbFilterDeviceOrder = "";
      this.dbFilterSubgroup = "";
      this.dbFilterFeed = "";
      this.dbFilterPosition = "";
      this.dbFilterRiskLevel = "";

      this.modal = false;
      this.$root.$emit("bv::toggle::collapse", "sidebar-backdrop");
      let LookUpURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let LookUpHeaders = this.$apikeyPost;
      let LookUpData = {
        Report: "DeviceReport",
        RequestType: "CEU",
        RequestVariable: this.deviceLocation,
        DataDict: [
          {
            FilterType: ["Device"],
            DeviceSort: "Asc",
            Location: this.dbFilterDeviceLocation.text,
            Subgroup: this.dbFilterSubgroup,
            Feed: this.dbFilterFeed,
            Position: this.dbFilterPosition.text,
            State: this.dbFilterRiskLevel,
          },
        ],
      };
      axios.post(LookUpURL, LookUpData, LookUpHeaders).then((response) => {
        this.responselist = response.data.Values;
        if (response.data.Values == "") {
          this.responseArray = [];
          this.responseArray = ["No Data"];
        } else if (response.data.Values != "") {
          /* let current = new Date();
      this.TodayDate = current.getFullYear()+','+(current.getMonth()+1)+','+current.getDate()+','+current.getHours()+','+current.getMinutes()+','+current.getSeconds(); */

          for (let i = 0; i < this.responselist.length; i++) {
            var QuoteStr = this.responselist[i][0];
            var FlowTime = "";
            var FlowDate = "";
            var FlowTimeDate = "";
            var BioFilmLvl = "";

            BioFilmLvl = this.responselist[i][10];
            FlowDate = this.responselist[i][8];
            FlowTime = this.responselist[i][9];
            if (FlowDate != "N/A") {
              FlowTimeDate = FlowDate + FlowTime;
              let d1 = new Date().toUTCString();
              d1 = new Date(d1).getTime();
              let d2 = new Date(FlowTimeDate).getTime();
              this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);
            } else if (FlowDate === "N/A") {
              this.time = "N/A";
            }

            if (BioFilmLvl == "N/A") {
              BioFilmLvl = "NoBio";
            }
            if (QuoteStr.includes("A")) {
              let FlowDate2 = this.responselist[i][8];
              let FlowTime2 = this.responselist[i][9];
              if (FlowDate2 != "N/A") {
                let FlowTimeDate2 = FlowDate2 + FlowTime2;
                let d1 = new Date().toUTCString();
                d1 = new Date(d1).getTime();
                let d2 = new Date(FlowTimeDate2).getTime();
                var time2 = Math.floor((d1 - d2) / 1000 / 60 / 60);
              } else if (FlowDate2 === "N/A") {
                time2 = "N/A";
              }
              let BioFilmLvl2 = this.responselist[i + 1][10];
              if (BioFilmLvl2 == "N/A") {
                BioFilmLvl2 = "NoBio";
              }

              let DevID = QuoteStr.slice(0, 9);
              let WorstScoreLvl = "";
              if (this.responselist[i][4] > this.responselist[i + 1][4]) {
                WorstScoreLvl = this.responselist[i + 1][4];
              }

              if (this.responselist[i][4] < this.responselist[i + 1][4]) {
                WorstScoreLvl = this.responselist[i][4];
              }

              if (this.responselist[i][4] == this.responselist[i + 1][4]) {
                WorstScoreLvl = this.responselist[i][4];
              }
              this.responseArray.push({
                DeviceID: DevID,
                BuildingName: this.responselist[i][1],
                Position: this.responselist[i][2],
                Feed: this.responselist[i][3],
                Recirculatory: this.responselist[i][11],
                Healthcare: this.responselist[i][12],
                Outdoor: this.responselist[i][13],
                Multipipe: this.responselist[i][15],
                Battery: this.responselist[i][14],
                Dropdown: "False",
                Pipe1: {
                  Score: this.responselist[i][4],
                  TempHi: this.responselist[i][5],
                  TempLo: this.responselist[i][6],
                  TempMed: this.responselist[i][7],
                  FlowRead: this.time,
                  PathogenRead: BioFilmLvl,
                },
                Pipe2: {
                  Score: this.responselist[i + 1][4],
                  TempHi: this.responselist[i + 1][5],
                  TempLo: this.responselist[i + 1][6],
                  TempMed: this.responselist[i + 1][7],
                  FlowRead: time2,
                  PathogenRead: BioFilmLvl2,
                },
                WorstScore: WorstScoreLvl,
              });
            } else if (QuoteStr.length == 9) {
              this.responseArray.push({
                DeviceID: QuoteStr,
                BuildingName: this.responselist[i][1],
                Position: this.responselist[i][2],
                Feed: this.responselist[i][3],
                Score: this.responselist[i][4],
                TempHi: this.responselist[i][5],
                TempLo: this.responselist[i][6],
                TempMed: this.responselist[i][7],
                FlowRead: this.time,
                PathogenRead: BioFilmLvl,
                Recirculatory: this.responselist[i][11],
                Healthcare: this.responselist[i][12],
                Outdoor: this.responselist[i][13],
                Multipipe: this.responselist[i][15],
                Battery: this.responselist[i][14],
                Dropdown: "False",
              });
            }
          }

          this.DeviceMessage = "Total Devices";
        }
      });

      let LookUpURL2 =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/statuscounts";
      let LookUpHeaders2 = this.$apikeyPost;
      let LookUpData2 = {
        RequestType: "Location",
        RequestVariable: this.deviceLocation,
        Company: this.CompanyName,
      };

      axios.post(LookUpURL2, LookUpData2, LookUpHeaders2).then((response) => {
        this.BadState = response.data.Bad[0];
        this.FairState = response.data.Fair[0];
        this.GoodState = response.data.Good[0];
        this.ExcellentState = response.data.Excellent[0];
        this.TotalDevices = response.data.Total[0];
      });
    },

    LookUpState: function(State) {
      (this.responseArray = []), (this.responselist = []);
      let StateType = State;
      let LookUpURLState =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let LookUpHeadersState = this.$apikeyPost;
      let LookUpDataState = {
        RequestType: "StateLocation",
        Report: "DeviceReport",
        RequestVariable: StateType,
        Company: this.CompanyName,
        Location: this.deviceLocation,
      };

      axios
        .post(LookUpURLState, LookUpDataState, LookUpHeadersState)
        .then((response) => {
          this.responselist = response.data.Values;

          for (let i = 0; i < this.responselist.length; i++) {
            var QuoteStr = this.responselist[i][0];
            var FlowTime = "";
            var FlowDate = "";
            var FlowTimeDate = "";
            var BioFilmLvl = "";

            BioFilmLvl = this.responselist[i][10];
            FlowDate = this.responselist[i][8];
            FlowTime = this.responselist[i][9];
            if (FlowDate != "N/A") {
              FlowTimeDate = FlowDate + FlowTime;
              let d1 = new Date().toUTCString();
              d1 = new Date(d1).getTime();
              let d2 = new Date(FlowTimeDate).getTime();
              this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);
            } else if (FlowDate === "N/A") {
              this.time = "N/A";
            }

            if (BioFilmLvl == "N/A") {
              BioFilmLvl = "NoBio";
            }

            this.responseArray.push({
              DeviceID: QuoteStr,
              BuildingName: this.responselist[i][1],
              Position: this.responselist[i][2],
              Feed: this.responselist[i][3],
              Score: this.responselist[i][4],
              TempHi: this.responselist[i][5],
              TempLo: this.responselist[i][6],
              TempMed: this.responselist[i][7],
              FlowRead: this.time,
              PathogenRead: BioFilmLvl,
              Recirculatory: this.responselist[i][11],
              Healthcare: this.responselist[i][12],
              Dropdown: "False",
            });
          }
          var StateWord = "";

          if (StateType == 4) {
            StateWord = "Low Risk";
            this.TotalDevices = this.ExcellentState;
          }
          if (StateType == 3) {
            StateWord = "Moderate Risk";
            this.TotalDevices = this.GoodState;
          }
          if (StateType == 2) {
            StateWord = "High Risk";
            this.TotalDevices = this.FairState;
          }
          if (StateType == 1) {
            StateWord = "Extremely High Risk";
            this.TotalDevices = this.BadState;
          }

          this.DeviceMessage =
            "Total Devices in " +
            StateWord +
            " State in " +
            this.deviceLocation;
        });
    },

    submitLocation() {
      (this.responseArray = []), (this.responselist = []), (this.BadState = "");
      this.FairState = "";
      this.GoodState = "";
      this.ExcellentState = "";
      this.TotalDevices = "";
      let LookUpURLLocation =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let LookUpHeadersLocation = this.$apikeyPost;
      let LookUpDataLocation = {
        RequestType: "Location",
        Report: "DeviceReport",
        RequestVariable: this.deviceLocation.text,
        Company: this.CompanyName,
      };
      axios
        .post(LookUpURLLocation, LookUpDataLocation, LookUpHeadersLocation)
        .then((response) => {
          this.responselist = response.data.Values;

          for (let i = 0; i < this.responselist.length; i++) {
            var QuoteStr = this.responselist[i][0];
            var FlowTime = "";
            var FlowDate = "";
            var FlowTimeDate = "";
            var BioFilmLvl = "";

            BioFilmLvl = this.responselist[i][10];
            FlowDate = this.responselist[i][8];
            FlowTime = this.responselist[i][9];
            if (FlowDate != "N/A") {
              FlowTimeDate = FlowDate + FlowTime;
              let d1 = new Date().toUTCString();
              d1 = new Date(d1).getTime();
              let d2 = new Date(FlowTimeDate).getTime();
              this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);
            } else if (FlowDate === "N/A") {
              this.time = "N/A";
            }

            if (BioFilmLvl == "N/A") {
              BioFilmLvl = "NoBio";
            }
            this.responseArray.push({
              DeviceID: QuoteStr,
              BuildingName: this.responselist[i][1],
              Position: this.responselist[i][2],
              Feed: this.responselist[i][3],
              Score: this.responselist[i][4],
              TempHi: this.responselist[i][5],
              TempLo: this.responselist[i][6],
              TempMed: this.responselist[i][7],
              FlowRead: this.time,
              PathogenRead: BioFilmLvl,
              Recirculatory: this.responselist[i][11],
              Healthcare: this.responselist[i][12],
              Dropdown: "False",
            });
          }
        });
      let LookUpURL2 =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/statuscounts";
      let LookUpHeaders2 = this.$apikeyPost;
      let LookUpData2 = {
        RequestType: "Location",
        RequestVariable: this.deviceLocation.text,
      };

      axios.post(LookUpURL2, LookUpData2, LookUpHeaders2).then((response) => {
        this.BadState = response.data.Bad[0];
        this.FairState = response.data.Fair[0];
        this.GoodState = response.data.Good[0];
        this.ExcellentState = response.data.Excellent[0];
        this.TotalDevices = response.data.Total[0];
      });
    },

    DeviceReportGen: function(id, DeviceType) {
      Vue.prototype.$DeviceID = id;
      Vue.prototype.$DetailToShow = DeviceType;

      this.$router.push("/TrendData");
    },

    setLocation(location) {
      this.location = location;
      this.modal = false;
    },

    showdetails(value) {
      this.WashbasinDetails = value;
      this.$refs["WashbasinDetailsModal"].show(this.WashbasinDetails);
    },
  },

  watch: {},
};
</script>

<style scoped>
@import "../../node_modules/bootstrap-slider/dist/css/bootstrap-slider.css";

input[type="text"],
select {
  padding: 7px 7px 7px 7px;

  border: solid 1px rgba(200, 200, 200, 0.5);
  width: 80%;
  border-radius: 25px;

  background-color: rgb(245, 245, 245);
}

.Grid > div {
  border: 1px solid black;
  border-radius: 5px;
  background-color: white;
  width: 100%;
}

.Grid {
  margin-top: 10px;
}

h4 {
  text-align: center;
}

.card-text {
  text-align: center;
}

.Auto {
  padding-left: 15px;
}

#UnitRAG {
  padding-top: 5px;
  margin-top: 5px;
}
.GraphContainer {
  width: 100%;
  padding-top: 10px;
}

.Graphs {
  width: 33.3%;
  float: left;
  border: solid 1px black;
  min-height: 16rem;
  color: black;
  background-color: rgb(236, 239, 245);
}

.TitleRow {
  padding: 0;
}

.centre {
  text-align: center;
}

.bottomLeft {
  width: 33.3%;
  border-right: solid 1px rgb(180, 180, 180);
  border-top: solid 1px rgb(180, 180, 180);
  padding-top: 10px;
  padding-bottom: 5px;
}

.row {
  margin: 0;
}

.bottomRight {
  width: 33.3%;
  border-top: solid 1px rgb(180, 180, 180);
  padding-top: 10px;
  padding-bottom: 5px;
}

.topLeft {
  width: 100%;
  padding-bottom: 10px;
}

.Icon {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 47.5%;
}

.GaugeText {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  text-decoration: underline;
  font-weight: bold;
  padding-top: 10px;
}

.PipeTitle {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  font-weight: bolder;
  padding-top: 10px;
  border-top: solid 1px black;
  color: black;
  font-size: 0.95rem;
}

.HeadingGaugeText {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  margin-top: 5px;
}

.Gauge {
  text-align: center;
  display: flex;
  justify-content: center;
}
#leftRow {
  margin: 0;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
}
.TempText {
  text-align: center;
  width: 100%;
}
.HeaderText,
.GaugeText {
  text-align: center;
  width: 100%;
  font-weight: 600;
  display: flex;
  justify-content: center;
  color: black;
}

h5 {
  font-size: 0.95rem;
  padding-top: 5px;
  padding-bottom: 5px;
  width: 100%;
}

#TempCol {
  text-align: center;
  margin-bottom: 5px;
}

#TempColMid {
  text-align: center;
  margin-bottom: 5px;
  margin-left: 5px;
  margin-right: 5px;
}

.centre,
.TempText {
  font-size: 0.7rem;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  color: #000;
}

.Gauge {
  padding-top: 5px;
}

.SearchFilters {
  padding-top: 30px;
}
#ScoreBar {
  height: 100%;
  width: 85%;
  margin: 0 auto;
  padding-top: 5%;
  padding-bottom: 5%;
}

#OverallScoreContainer {
  position: relative;
  border: solid 1px black;
}
#ScoreSlider {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 409;
  width: 100%;
}

.progress {
  border-radius: 0px;
}

.dashCol {
  background-color: rgb(240, 248, 255);
  border: solid 1px rgb(180, 180, 180);
  border-radius: 25px;

  margin-left: 2rem;
  margin-right: 2rem;
  margin-top: 1rem;
  margin-bottom: 1rem;

  overflow: contain;
}
.multiPipeHeader {
  text-align: center;
  width: 100%;

  background-color: rgb(200, 208, 215);
  height: 5rem;
  border: 0px;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
.lowRiskHeader {
  text-align: center;
  width: 100%;

  background-color: #28a745;
  height: 5rem;
  border: 0px;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
.modRiskHeader {
  text-align: center;
  width: 100%;

  background-color: rgb(252, 252, 38);
  height: 5rem;
  border: 0px;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;

  border-bottom: solid 2px rgb(180, 180, 180);
  outline-offset: 2px;
}
.highRiskHeader {
  text-align: center;
  width: 100%;

  background-color: #ffc107;
  height: 5rem;
  border: 0px;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
.extHighRiskHeader {
  text-align: center;
  width: 100%;

  background-color: #dc3545;
  height: 5rem;
  border: 0px;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
.dashRow {
  display: flex;
  background-color: #ff000000;
  padding: 0.5rem;
}
.dashText {
  color: rgb(14, 14, 14);
}
.riskText {
  padding: 0 !important;
  margin: 0 !important;
  text-align: center;
  font-size: 0.8rem;
  font-weight: bold;
  color: rgb(14, 14, 14);
}
.dashDeviceText {
  font-size: 0.9rem;
  font-weight: 800;
  padding-top: 0.1rem;
}
.dashHeaderText {
  font-size: 0.8rem;
  padding-bottom: 0.2rem;
}

.col {
  padding-left: 7px;
  padding-right: 7px;
}

#Selector {
  text-align: center;
  width: 100%;
  padding: 0;
  margin: 0;
}

.pageHeader {
  text-align: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-left: 3rem;
  margin-right: 3rem;
}

#ButtonRow {
  padding-bottom: 1.5rem;
  border-bottom: solid 2px gray;
  margin-left: 3rem;
  margin-right: 3rem;
}

.DeviceStatusText {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

label {
  margin: 0;
}

.DeviceOverview {
  width: 48%;
  float: left;
  color: black;
  margin-right: 2%;
  flex: 1;
}

.PieChartDiv {
  width: 100%;
  float: right;
}

.DeviceInfoTop {
  display: flex;
  width: 100%;
  overflow: hidden;
}
.chartBox {
  height: 95%;
  margin: 1rem 1rem 0rem 1rem;
  text-align: left;
  background-color: #eeeeee;
  border: 0;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.DoughnutChart {
  margin-left: auto;
  margin-right: auto;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 225px;
}

/* copy from elsewhere for testing */

@import "../../node_modules/bootstrap-slider/dist/css/bootstrap-slider.css";

/* .form-control {
  width: 100%;
  border: solid 1px rgba(200, 200, 200, 0.5);
  border-radius: 25px;
  background-color: rgb(245, 245, 245);
  font-size: 0.9rem;
} */

.Grid > div {
  border: 1px solid black;
  border-radius: 5px;
  background-color: white;
  width: 100%;
}

.Grid {
  margin-top: 10px;
}

h4 {
  text-align: center;
}

.Auto {
  padding-left: 15px;
}

.centre {
  text-align: center;
}

.row {
  margin: 0;
}

.Icon {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 47.5%;
}

.Gauge {
  padding-top: 5px;
}

.col {
  padding-left: 7px;
  padding-right: 7px;
}

label {
  margin: 0;
}

.DeviceOverview {
  width: 48%;
  float: left;
  color: black;
  margin-right: 2%;
  flex: 1;
}

.PieChartDiv {
  width: 50%;
  float: right;
}

/* Updates 240122 */

.HealthcareIcon {
  background-color: #6544a4;
  height: 1.7rem;
  width: 1.7rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.RecirculatoryIcon {
  background-color: #3d85c7;
  height: 1.7rem;
  width: 1.7rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.BatteryIcon {
  background-color: #29d191;
  height: 1.7rem;
  width: 1.7rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.MultiplePipe {
  background-color: rgb(0, 0, 0);
  height: 1.7rem;
  width: 1.7rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.OutdoorIcon {
  background-color: #684e4c;
  height: 1.7rem;
  width: 1.7rem;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.legendText {
  color: black;
  font-size: 0.75rem;
}

.sb-col1 {
  margin-top: 10px;
  margin-bottom: 8px;
}
.sb-col2 {
  margin-top: 1.5rem;
  border-bottom: solid 2px rgb(220, 220, 220);
  width: 90%;
  margin-left: 5%;
}
.checkboxes1 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-left: 25%;
}

.supportTextArea {
  min-height: 5rem;
  width: 100%;
  border-radius: 10px;
  padding: 0.5rem;
}
.noteCol {
  text-align: center;
  background-color: white;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  border: solid 1px rgb(180, 180, 180);
  padding: 0.5rem;
}
.NotesRow {
  border-top: solid 1px rgb(180, 180, 180);
}
.notePreviewRow {
  background-color: rgb(245, 245, 245);
  padding-top: 0.25rem;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
  margin-top: 1rem;
}
.notesCollapsible {
  background: rgba(200, 200, 200, 0);
  border: none;
}
.noteTitleP {
  text-align: center;
  font-weight: 600;
  padding-top: 0.5rem;
}
.noteDetails {
  text-align: center;
}
.deleteNoteButton {
  background-color: rgb(245, 245, 245);
  border-radius: 15px;
  border: solid 1px black;
}
.deleteNoteButton:hover {
  background-color: rgb(255, 255, 255);
}
/* .notePreivewContent{
} */

.NewNoteModal {
  text-align: center;
  align-items: center;
  align-content: center;
}

.NewNoteTitle {
  width: 100%;
  padding: 7px 7px 7px 7px;
  border: solid 1px rgba(200, 200, 200, 0.5);
  border-radius: 15px;
  background-color: rgb(245, 245, 245);
}
.NewNoteTopRow {
  margin-bottom: 1rem;
}
.NewNoteBottomRow {
  margin-bottom: 1rem;
}
.NotesModalContainerDiv {
  text-align: center;
}
.NoteContainer {
  margin-bottom: 1rem;
  overflow-x: scroll;
  max-height: 55vh;
}
.NotesHeader {
  font-weight: 600;
  font-size: 11.2px;
}
.NotesContent {
  height: 70px;
  width: 50%;
  border-right: solid 1px rgb(180, 180, 180);
}
.NotesContent2 {
  height: 70px;
  width: 50%;
}

.calibContainer {
  width: 90%;
  border-radius: 15px;
  border: solid 1px rgb(0, 204, 255);
  margin-left: 5%;
  background: #eeeeee;
}
.col-line-mod {
  border-top: solid 1px rgb(200, 200, 200);
  width: 95%;
  margin-left: 2.5%;
  margin-top: 2rem;
}

p.tiny {
  color: gray;
  font-size: x-small;
}

p.cardhead {
  color: gray;
  text-decoration: underline;
  font-size: medium;
  margin-bottom: 0;
}

p.cardbody {
  color: black;
  font-size: medium;
  margin: 0.25rem;
}

.left {
  float: left;
}

.right {
  float: right;
}

.moderaterisk {
  background-color: rgb(252, 252, 38);
  color: #000;
}

.cardcol {
  border: solid lightgray;
}

.HandwashIcon {
  background-color: rgb(118, 214, 168);
}
</style>
